import { Box, Typography } from "@mui/material";
import React from "react";
import CallIcon from "../assets/SVG/callIcon";
import EditIcon from "../assets/SVG/editIcon";
import FlagIcon from "../assets/SVG/flagIcon";
import PhoneIcon from "../assets/SVG/phoneIcon";
import groupPic from "../assets/image/groupPic.png";

export default function CardGroup({
  pic,
  name,
  groupName,
  color,
  phone,
  mobile,
  count,
  onClick,
  user,
  tripsCount,
}) {
  // console.log(user.pic);
  return (
    <Box
      sx={{ cursor: "pointer" }}
      mt="20px"
      p="10px"
      bgcolor="#F5F9FF"
      borderRadius="12px"
      minWidth="240px"
      height="186px"
      boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
      onClick={onClick}
    >
      <Box display={"flex"} justifyContent="space-between">
        <Box alignItems="center" display={"flex"}>
          <img
            style={{
              width: "60px",
                height: "60px",
              borderRadius: "50%",
              border: `solid 3px ${color}`,
            }}
            src={pic || groupPic}
          />
          <Box mr="10px">
            <Typography
              fontWeight="bold"
              color="var(--emr-font)"
              fontSize={"20px"}
            >
              {name}
            </Typography>
            <Typography mt="8px" fontSize={"14px"} color="var(--emr-disable)">
              {user?.name}
            </Typography>
          </Box>
        </Box>
        <Box ml={"5px"} mt="5px">
          <EditIcon />
        </Box>
      </Box>
      <Box mt="20px" mr="5px">
        {user?.tel && (
          <Box display={"flex"}>
            <PhoneIcon />
            <Typography mr="8px" fontSize={"14px"} color="#6C6969">
              {user?.tel}
            </Typography>
          </Box>
        )}
        {user?.phone && (
          <Box mt="11px" display={"flex"}>
            <CallIcon />
            <Typography mr="8px" fontSize={"14px"} color="#6C6969">
              {user?.phone}
            </Typography>
          </Box>
        )}
        <Box mt="11px" display={"flex"}>
          <FlagIcon />
          <Typography mr="8px" fontSize={"14px"} color="#6C6969">
            {!tripsCount || tripsCount === 0
              ? "اردویی برگزار نشده"
              : `${tripsCount} اردو برگزار شده`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
